var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyclingBmXfree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.6,95.3c5.1,0,9.9,2,13.5,5.6c7.5,7.5,7.5,19.6,0,27.1c-3.6,3.6-8.4,5.6-13.5,5.6s-9.9-2-13.5-5.6 c-7.5-7.5-7.5-19.6,0-27.1C55.7,97.3,60.5,95.3,65.6,95.3 M65.6,92.6c-5.6,0-11.2,2.1-15.5,6.4c-8.5,8.5-8.5,22.4,0,30.9 c4.3,4.3,9.9,6.4,15.5,6.4c5.6,0,11.2-2.2,15.5-6.4c8.5-8.5,8.5-22.4,0-30.9C76.8,94.7,71.2,92.6,65.6,92.6L65.6,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,31c5.1,0,9.9,2,13.5,5.6c7.5,7.5,7.5,19.6,0,27.1c-3.6,3.6-8.4,5.6-13.5,5.6s-9.9-2-13.5-5.6 c-7.5-7.5-7.5-19.6,0-27.1C72.2,33,77,31,82.1,31 M82.1,28.3c-5.6,0-11.2,2.1-15.5,6.4c-8.5,8.5-8.5,22.4,0,30.9 c4.3,4.3,9.9,6.4,15.5,6.4s11.2-2.1,15.5-6.4c8.5-8.5,8.5-22.4,0-30.9C93.3,30.4,87.7,28.3,82.1,28.3L82.1,28.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.9,44.7h14.7c1.4,0,2.7-0.6,3.7-1.5l16.4-16.3c2-2,2-5.3,0-7.3c-2-2-5.3-2-7.3,0L43.5,34.4H22c-2.3,0-4.7,0.8-6.5,2.6 c-1.8,1.8-2.6,4.1-2.6,6.4v36.3l18-18V44.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8,
    cy: 21.3,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,82.3c0-2.8-2.2-5.1-5-5.1H70.7L50.3,56.8c-2-2-5.3-2-7.3,0L15.8,84c2.3,2.3,5.2,3.4,8.2,3.4h59.2 C86,87.4,88.3,85.1,88.3,82.3z M37.3,77.1l9.4-9.4l9.4,9.4H37.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,77.1h-41.1v37.3c0,12-5.7,22.8-14.6,29.6h4.2c0.5-0.4,0.9-0.8,1.4-1.3c3.7-3.7,6.6-7.9,8.6-12.7 c2.1-4.9,3.1-10.2,3.1-15.6V79.9H144V77.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclingBmXfree);
export default __webpack_public_path__ + "static/media/cyclingBMXfree.8cee393af916c2ad97726794daa0ead3.svg";
export { ForwardRef as ReactComponent };